import { render, staticRenderFns } from "./MultiLangMaintainCore.vue?vue&type=template&id=ceccf620&scoped=true"
import script from "./MultiLangMaintainCore.vue?vue&type=script&lang=js"
export * from "./MultiLangMaintainCore.vue?vue&type=script&lang=js"
import style0 from "./MultiLangMaintainCore.vue?vue&type=style&index=0&id=ceccf620&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceccf620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceccf620')) {
      api.createRecord('ceccf620', component.options)
    } else {
      api.reload('ceccf620', component.options)
    }
    module.hot.accept("./MultiLangMaintainCore.vue?vue&type=template&id=ceccf620&scoped=true", function () {
      api.rerender('ceccf620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/i18n/MultiLangMaintainCore.vue"
export default component.exports